import styled, { css } from 'styled-components';

export const Footer = styled.footer`
    /* margin-top: 10px; */

    padding: 40px;

    background-color: #1A1B1C;
    min-height: 600px; 
    width: 100vw;
    z-index: 100;

    font-family: Montserrat;
    font-size: 14px;
    color: #FFF;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

export const FooterLeft = styled.div`
    
    min-height: 400px; 
    width: 30%;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    span{
        cursor:pointer;
        margin-bottom:5%!important;
    }

    span p{
        cursor:pointer;
        margin-bottom:-8%!important;
    }


    span:hover{
        text-decoration:underline;
    }
`

export const FooterRight = styled.div`

    /* background-color: #c8c5c4; */

    min-height: 400px; 
    width: 70%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
`

export const Links = styled.div`
    width: 100%;
    height: 50%;

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-evenly;

    flex-wrap: wrap;
`
export const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props=>props.align || 'center'};
    justify-content: center;

    text-align: left;

    flex: 1;

    a{
        font-size: 15px;
        font-weight: 600;
        color: rgba(255,255,255,0.8);
        
        line-height: 1.8em;

        transition: opacity 0.5s ease-in-out;
    }

    a:hover{
        opacity: 0.6;
    }
`
export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    text-align: left;

    flex: 1;
`

export const Divider = styled.div`
    width: 100%;
    height: 1px;

    background-color: rgba(193, 194, 195, 0.4);

    margin: 5px 10px;
`;

export const IconBackground = styled.a`
    width: 40px;
    height: 40px;

    border-radius: 50%;

    background-color: rgb(255, 255, 255);

    margin: 5px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    cursor: pointer;


    i{
        margin: 0 !important;
        margin-top: -2px;
    }

`;


export const Socials = styled.div`
    width: 100%;
    height: 50%;

    flex-wrap: wrap;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;

`

export const FooterBody = styled.div`

    width: 100%;

    flex-wrap: wrap;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

export const SectionTitle = styled.p`

    color: #FFF;

    font-weight: 700;
    text-align: center;

    margin-bottom: -2px;
    margin-top:14px;
    padding: 3px;

    ${props=>props.bigger ? css`font-size: 19px ` : css`font-size: 18px `  }

    ${props=>props.links && css`border-bottom: 2px solid #c1c2c3` }

    ${props=>props.clickable && css`
    
        transition: opacity 0.5s ease-in-out;
        
        &:hover{
            opacity: 0.6;
        }
    ` }


`
export const Copyright = styled.p`
    font-size: 15px;
    font-weight: 700;
    text-align: center;

    margin: 30px 0;
`

export const FooterFooter = styled.p`
    font-size: 14px;
    text-align: center;
    font-weight: 500;

    margin-top: 40px;
    padding: 20px;

    a {
        margin-left: 5px;
    }
`
export const Icon = styled.p`
    cursor: pointer
`